import { useAtomValue } from 'jotai';
import { useSidePanel } from '../side-panel-provider';
import { isAnnotationImported } from '../utils/is-annotation-imported';
export const useMLAnnotations = () => {
  const {
    mlAnnotationsAtom,
    importedMLAnnotationIdsAtom
  } = useSidePanel();
  const mlAnnotations = useAtomValue(mlAnnotationsAtom);
  const importedMLAnnotationIds = useAtomValue(importedMLAnnotationIdsAtom);
  const pendingMLAnnotations = mlAnnotations.filter(annotation => {
    return !isAnnotationImported(annotation, importedMLAnnotationIds);
  });
  return {
    pendingMLAnnotations,
    mlAnnotations,
    importedMLAnnotationIds
  };
};